import { Component, OnInit, ViewChild } from "@angular/core";
import { MsVisiteeStaffTableComponent } from "./ms-visitee-staff-table/ms-visitee-staff-table.component";
import { DataService_MultiStationVisiteeMaintenance } from "../shared/data.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { VisiteeUpdateRequest } from "../shared/VisiteeUpdateRequest";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-ms-visitee-manual-mode",
	templateUrl: "./ms-visitee-manual-mode.component.html",
	styleUrls: ["./ms-visitee-manual-mode.component.css"],
})
export class MsVisiteeManualModeComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private visitorService: DataService_MultiStationVisiteeMaintenance,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.School = school;
		});

		this.loadPersonType();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////

	subscription: any;

	School: any;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingPersonType: boolean = true;
	SelectedPersonType: any;
	lstPersonType: any = [];

	ActiveOptionID: any = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	lstStaff: any = [];

	loading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	@ViewChild(MsVisiteeStaffTableComponent)
	TableRef: MsVisiteeStaffTableComponent;

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////

	loadPersonType() {
		this.LoadingPersonType = true;

		var result = this.visitorService.StaffPersonTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstPersonType = response;

				this.lstPersonType.unshift({
					PersonTypeID: -1,
					PersonTypeDesc: "Any",
				});

				if (this.lstPersonType.length > 0) {
					this.SelectedPersonType = this.lstPersonType[0];
				}

				this.LoadingPersonType = false;
			},
			(error) => {
				this.LoadingPersonType = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////

	onSearch() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.visitorService.VisiteeStaffSelectList(this.School.SchoolID, this.SelectedPersonType.PersonTypeID, this.ActiveOptionID);
		result.subscribe(
			(response) => {
				this.lstStaff = response;

				for (var z = 0; z < this.lstStaff.length; z++) {
					var next = this.lstStaff[z];

					next.OriginalVisiteeEnabled = next.VisiteeEnabled;
					next.OriginalNotifyByEmail = next.NotifyByEmail;
					next.OriginalEmail = next.Email;
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		this.Processing = true;

		var lstPIDs: number[] = [];
		var lstVisiteeEnabled: number[] = [];
		var lstNotifyByEmail: number[] = [];
		var lstEmail: string[] = [];

		var lstNotifyByText: number[] = [];
		var lstPhone: string[] = [];

		for (var z = 0; z < this.TableRef.lstPerson.length; z++) {
			var next = this.TableRef.lstPerson[z];

			if (next.OriginalVisiteeEnabled != next.VisiteeEnabled || next.OriginalNotifyByEmail != next.NotifyByEmail || next.OriginalEmail != next.Email) {
				lstPIDs = [...lstPIDs, next.PersonID];
				lstVisiteeEnabled = [...lstVisiteeEnabled, next.VisiteeEnabled == true ? 1 : 0];
				lstNotifyByEmail = [...lstNotifyByEmail, next.NotifyByEmail == true ? 1 : 0];
				lstEmail = [...lstEmail, next.Email];

				lstNotifyByText = [...lstNotifyByText, -1];
				lstPhone = [...lstPhone, ""];
			}
		}

		this.Processing = false;

		if (lstPIDs.length == 0) {
			return;
		}

		this.confirmationService.confirm({
			key: "manualconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "You are about to update " + lstPIDs.length + " visitees. Do you want to continue?",
			header: "Confirm Update Visitees",
			icon: "fa",
			accept: () => {
				this.FinishUpdate(lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone);
			},
		});
	}

	FinishUpdate(lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone) {
		this.Processing = true;

		var parms: VisiteeUpdateRequest = {
			DeactivateNotInList: 0,
			lstPersonID: lstPIDs,
			lstActive: lstVisiteeEnabled,
			lstNotifyByEmail: lstNotifyByEmail,
			lstNotifyByText: lstNotifyByText,
			lstEmail: lstEmail,
			lstPhoneNbr: lstPhone,
		};

		var result = this.visitorService.VisiteeUpdateByTable(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if ((response.Success = true)) {
					this.onSearch();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "manualresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update visitees: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onReset() {
		for (var z = 0; z < this.lstStaff.length; z++) {
			var next = this.lstStaff[z];

			next.VisiteeEnabled = next.OriginalVisiteeEnabled == true ? true : false;
			next.NotifyByEmail = next.OriginalNotifyByEmail == true ? true : false;
			next.Email = next.OriginalEmail.toString();
		}
	}

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true || this.LoadingPersonType == true;
	}

	/////////////////////////////////////////////////////////////
}
